import React from 'react';
import { STATS } from '../../mock';

export default function Stats() {
  // Duplicate for marquee effect (visual only)
  const loop = [...STATS, ...STATS];
  return (
    <section className="relative py-20 md:py-28 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="font-serif text-center text-white text-[34px] md:text-[52px] leading-[1.05] tracking-tight">
          Numbers That Can't
          <br />
          Be Ignored.
        </h2>
      </div>

      <div className="mt-14 overflow-hidden">
        <div className="flex gap-4 md:gap-6 marquee-track">
          {loop.map((s, i) => (
            <div
              key={i}
              className="shrink-0 w-[260px] md:w-[300px] rounded-2xl border border-white/10 bg-navy-900/60 px-6 py-6"
            >
              <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500">
                {s.label}
              </p>
              <p className="mt-3 font-serif text-white text-[40px] md:text-[44px] leading-none">
                {s.value}
              </p>
              <p className="mt-3 inline-flex items-center gap-2 text-[12px] text-amber-300/90">
                <span className="h-1.5 w-1.5 rounded-full bg-amber-300" />
                {s.delta}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
